// extracted by mini-css-extract-plugin
module.exports = {"section":"Paragraphs_section__Gpl_R","image":"Paragraphs_image__G4JLi"};